import { createHttpInstance } from "@/services/httpInstance";

/**
 * Cliente propio de afiliación asistida. Se crea aparte de los compartidos para poder cambiarle el
 * host sin tocar a ningún otro servicio. Nace sin `baseURL` a propósito: el host se decide en cada llamada según el feature flag,
 * así que los servicios le pasan la URL completa.
 */
export const assistedAffiliationClient = createHttpInstance("default", "");
